export const DEFAULT_RANGE_TYPE = "today";

export function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return +d;
}

export function toTimestamps(type, customFrom, customTo) {
  const now = Date.now();
  const day = 86400000;
  switch (type) {
    case "today": return { from: startOfToday(), to: now };
    case "1w":  return { from: now - 7 * day,  to: now };
    case "30d": return { from: now - 30 * day, to: now };
    case "90d": return { from: now - 90 * day, to: now };
    case "custom":
      return {
        from: +new Date(customFrom + "T00:00:00"),
        to:   +new Date(customTo   + "T23:59:59")
      };
    default: return { from: 0, to: now };
  }
}
